/** Contador − 2 +: quantidade de produto na venda, na entrada e no gasto do serviço. */
import { IconMinus, IconPlus } from './Icons';

export function Stepper({
  value,
  onChange,
  min = 0,
  max = 100_000,
  step = 1,
  label,
  format,
  size,
}: {
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  step?: number;
  /** o que está sendo contado, para o leitor de tela ("Creme para mãos") */
  label: string;
  /** texto do número ("4 g") */
  format?: (v: number) => string;
  size?: 'lg';
}) {
  const shown = format ? format(value) : String(value);
  return (
    <span className={`stepper${size ? ` stepper--${size}` : ''}`} role="group" aria-label={label}>
      <button type="button" aria-label={`Menos ${label}`} disabled={value <= min} onClick={() => onChange(Math.max(min, value - step))}>
        <IconMinus />
      </button>
      <b aria-live="polite">{shown}</b>
      <button type="button" aria-label={`Mais ${label}`} disabled={value >= max} onClick={() => onChange(Math.min(max, value + step))}>
        <IconPlus />
      </button>
    </span>
  );
}
